export default "__VITE_ASSET__FZ5KNhNk__"